import { useTranslation } from "react-i18next"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog"

export function ConfirmationDialog({
  children,
  action,
  title,
  description,
}: {
  children: React.ReactNode
  action: React.ReactNode
  title?: string
  description?: string
}) {
  const { t } = useTranslation("common")
  return (
    <AlertDialog>
      {children}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {title || t("confirmation_dialog.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description || t("confirmation_dialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel">
            {t("actions.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction asChild data-testid="confirm">
            {action}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export const ConfirmationDialogTrigger = AlertDialogTrigger
